import React from "react";
import Button, { ButtonProps } from "./index";

type ButtonPrimaryProps = {
	bg?: string;
	hover?: string;
	className?: string;
} & ButtonProps;

const ButtonPrimary = ({
	bg,
	hover,
	className,
	...props
}: ButtonPrimaryProps): JSX.Element => {
	return (
		<Button
			{...props}
			size="full"
			className={` bg-sky-500 hover:bg-sky-600 !text-white focus:outline-sky-400 ${hover} ${className}`}
		></Button>
	);
};

export default ButtonPrimary;
